import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { LangService } from "src/app/core/services/lang.service";

import { ModalService } from "src/app/shared/services/modal.service";

import { GridService } from "src/app/shared/services/grid.service";
import { CommonService } from "src/app/features/ac/services/common.service";
import { Employee } from "src/app/features/ac/models/employee.model";
import { UserListComponent } from "src/app/features/ac/components/forms/modals/user-list.component";

@Component({
  selector: "app-hr-req-list",
  templateUrl:
    "../../../templates/forms/modals/new-hr-requisition-letter.component.html"
})
export class NewHrRequisitionLetterComponent implements OnInit {
  @ViewChild("modalContainer", { static: true, read: ViewContainerRef }) container;

  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  options = ["person 1", "person 2", "person 3"];
  employee: Employee;
  private modal: ModalService;

  constructor(
    public langService: LangService,
    public gridService: GridService
  ) {}

  ngOnInit() {}

  onCLickOpenEmployeeList() {
    this.modal
      .createNewModal(this.container, UserListComponent, true)
      .subscribe(value => {
        console.log('value: ', value);        
        this.employee = new Employee(value)
      });
  }
}
